<template lang="pug">
div
  app-display(
    label="É espólio:",
    :content="interessado.espolio ? 'Sim' : 'Não'",
    v-if="interessado.espolio != null"
    :class = "compararInteressado && compararInteressado.mudouEspolioInteressados ? 'text': '' "
  )

  informacoes-pessoa(
    :pessoa="interessado.pessoa",
    :compararInformacoesPessoa = "compararInteressado && compararInteressado.mudouPessoa"
  )

  app-collapse(title="Sócios" v-if="interessado.socios && interessado.socios.length > 0")
    app-collapse(v-for="(socio, index) in interessado.socios" :title="socio.pessoaFisica.nome", :key="socio.cpf")
      informacoes-pessoa(
        :pessoa="socio",
        :isSocioRepresentanteLegal="true"
        :compararInformacoesPessoa = "compararInteressado && compararInteressado.mudouSocioRepresentanteLegal  "
        :compararIsSocioRepresentanteLegal = "compararInteressado && compararInteressado.mudouSocioRepresentanteLegal"
      )
      listagem-documentos(
        v-if="socio.documentos && socio.documentos.length > 0"
        :documentos="socio.documentos",
        :idSocio="socio.id"
        :idCadastro="idCadastro",
        ownerDocumento="socio",
        :compararDocumentos = "compararInteressado && compararInteressado.mudouDocumentosInteressado"
        :versaoCadastro = "versaoCadastro"
      )

  app-divider(label="Endereço")
    informacoes-endereco.margin-top(:endereco="enderecoInteressado", slot="body", :mudouEndereco = "compararInteressado && compararInteressado.mudouEndereco")

  app-divider(v-if="hasConjuge" label="Cônjuge")
    informacoes-pessoa.margin-top(
      v-if="!isViuvo"
      :pessoa="interessado.conjuge"
      slot="body"
      :isConjuge="hasConjuge",
      :compararInformacoesPessoa = "compararInteressado && compararInteressado.mudouConjugeInteressado"
    )
    div(v-else, slot="body")
      app-display(
        label="Possui certidão de óbito?",
        :content="interessado.conjuge.pessoaFisica.temCertidaoObito ? 'Sim': 'Não' ",
        :class = "compararInteressado && compararInteressado.mudouPessoa.mudouTemCertidaoObito ? 'text': '' "
      )
      app-display(
        label="CPF:",
        :content="interessado.conjuge.pessoaFisica.cpf"
        :class = "compararInteressado && compararInteressado.mudouPessoa.mudouCPF ? 'text': '' "
      )
      app-display(
        label="Nome:",
        :content="interessado.conjuge.pessoaFisica.nome",
        :class = "compararInteressado && compararInteressado.mudouPessoa.mudouNome ? 'text': '' "
      )

</template>

<script>
import AppCollapse from '@/components/AppCollapse'
import AppDivider from '@/components/AppDivider'
import AppDisplay from '@/components/AppDisplay'

import InformacoesEndereco from '@/components/informacoesCadastro/common/InformacoesEndereco'
import InformacoesPessoa from '@/components/informacoesCadastro/common/InformacoesPessoa'
import ListagemDocumentos from '@/components/informacoesCadastro/common/ListagemDocumentos'

export default {
  props: {
    interessado: {
      type: Object,
      required: true
    },
    idCadastro: {
      type: String,
      required: true
    },
    compararInteressado: {
      type: Object,
      required: true
    },
    versaoCadastro: {
      type: String,
      default: 'MAX(versao_json)'
    }
  },

  components: {
    AppCollapse,
    InformacoesEndereco,
    InformacoesPessoa,
    AppDisplay,
    ListagemDocumentos,
    AppDivider
  },

  computed: {
    enderecoInteressado () {
      return this.interessado.pessoa.endereco ? this.interessado.pessoa.endereco : {}
    },

    hasConjuge () {
      return (this.interessado.pessoa.pessoaFisica && this.interessado.conjuge) && this.interessado.conjuge.pessoaFisica.cpf !== null
    },

    isViuvo () {
      if (!this.interessado.pessoa.pessoaFisica) {
        return false
      }
      return this.interessado.pessoa.pessoaFisica.estadoCivil === 'VIUVO'
    }
  }

}
</script>
<style lang="scss" scoped>
.margin-top {
  margin-top: 10px;
}
>>> .text .text{
    color: #ff0000 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/informacoesCadastro/cadastrosOnline/InformacoesInteressado.vue